type FabWalletProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const FabWallet = ({className, size = 22, fill = 'currentColor'}: FabWalletProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="28 28 24 24"
        fill="none"
        stroke={fill}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden
    >
        <path d="M47.5899 43.5055V45.6139C47.5899 46.3967 47.279 47.1475 46.7254 47.701C46.1718 48.2546 45.4211 48.5655 44.6382 48.5655H31.5666C31.1192 48.5655 30.6902 48.3878 30.3739 48.0715C30.0576 47.7552 29.8799 47.3262 29.8799 46.8789V35.9156C29.8799 35.4682 30.0576 35.0392 30.3739 34.7229C30.6902 34.4066 31.1192 34.2289 31.5666 34.2289H44.6382C45.4211 34.2289 46.1718 34.5399 46.7254 35.0934C47.279 35.6469 47.5899 36.3977 47.5899 37.1806V39.2889" />
        <path d="M44.9623 34.2457L44.4284 32.1104C44.4013 32.0017 44.3527 31.8996 44.2856 31.8099C44.2185 31.7202 44.1342 31.6447 44.0376 31.588C43.9411 31.5312 43.8342 31.4943 43.7232 31.4793C43.6122 31.4643 43.4993 31.4715 43.3911 31.5007L33.2534 34.2288" />
        <path d="M32.4136 36.7589H34.1002" />
        <path d="M35.7866 36.7589H37.4733" />
        <path d="M39.1602 36.7589H40.8469" />
        <path d="M42.5332 36.7589H44.2198" />
        <path d="M32.4136 46.0355H34.1002" />
        <path d="M35.7866 46.0355H37.4733" />
        <path d="M39.1602 46.0355H40.8469" />
        <path d="M42.5332 46.0355H44.2198" />
        <path d="M47.5932 39.2888H44.2198C43.2883 39.2888 42.5332 40.044 42.5332 40.9755V41.8189C42.5332 42.7504 43.2883 43.5055 44.2198 43.5055H47.5932C48.5247 43.5055 49.2798 42.7504 49.2798 41.8189V40.9755C49.2798 40.044 48.5247 39.2888 47.5932 39.2888Z" />
    </svg>
);

export default FabWallet;
